import React from "react";
import { JsonLd } from "../components/common/JsonLd";
import { SEOHelmet } from "../components/common/SEOHelmet";
import { PATH_ERGOTHERAPIE } from "../utils/constants";
import pageData from "../data/pages/ergotherapie.json";
import { buildSeoPageGraph } from "../utils/structured-data";

type Section = {
  title: string;
  text?: string;
  content?: string[];
};

const data = { sections: pageData.sections as Section[] };

export default function OccupationalTherapyPage() {
  return (
    <>
      <SEOHelmet page="ergotherapie" pathname={PATH_ERGOTHERAPIE} />
      <JsonLd data={buildSeoPageGraph(PATH_ERGOTHERAPIE, "ergotherapie")} />

      <main id="main-content" tabIndex={-1} className="space-y-14">
        <article>
          <header>
            <h1
              className="text-3xl sm:text-4xl font-semibold tracking-tight text-gray-900 dark:text-white mb-6"
              id="main-heading"
            >
              Was ist Ergotherapie?
            </h1>
          </header>
          <section aria-labelledby="main-heading">
            <p className="text-base text-gray-500 dark:text-gray-400 leading-relaxed">{data.sections[0].text}</p>
          </section>
        </article>

        {data.sections.slice(1).map((section, index) => (
          <article key={index}>
            <section aria-labelledby={`section-${index}`}>
              <h2
                id={`section-${index}`}
                className="text-xl sm:text-2xl font-semibold tracking-tight text-ergo-600 dark:text-ergo-400 mb-4"
              >
                {section.title}
              </h2>
              {section.text && (
                <p className="text-base text-gray-500 dark:text-gray-400 leading-relaxed">{section.text}</p>
              )}
              {section.content && (
                <ul
                  className="list-disc marker:text-ergo-400 dark:marker:text-ergo-500 list-inside space-y-2 text-base text-gray-500 dark:text-gray-400"
                  aria-label="Grundprinzipien der Ergotherapie"
                >
                  {section.content.map((item, itemIndex) => (
                    <li key={itemIndex} className="leading-relaxed">
                      {item}
                    </li>
                  ))}
                </ul>
              )}
            </section>
          </article>
        ))}
      </main>
    </>
  );
}
